import { useLazyQuery, useQuery } from "@apollo/client";
import { CategoriesQuery } from "../../../__generated__/CategoriesQuery";
import { CATEGORIES } from "../categories.queries";

export const useCategories = () => {
  return useQuery<CategoriesQuery>(CATEGORIES);
};

export const useLazyCategories = () => {
  return useLazyQuery<CategoriesQuery>(CATEGORIES);
};
